import Layout from "./Layout";
import Sports from "./Sports";
const Home = () => {
  return (
    <Layout>
      <Sports />
    </Layout>
  );
};

export default Home;
